export const SIDE_PANEL_WIDTH = 200
